export default __webpack_public_path__ + "locales/sr-Cyrl-RS/WebPlugins.json?hash=9e9a431546e4ba61b447195bfae58b5b";